import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form';
import ErrorAlert from '../../../alerts/components/BorderedAlertsWithIcons';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import { withRouter } from 'react-router-dom'
import '../../../../scss/component/change-password.scss'
class ChangePassword extends Component {

  state = {
    errMsg: null,
    fillForm: null,
    error: false,
    loading: null,
    changePasswordError: null
  }
  async onSubmit (values) {
    this.setState({
      loading: true
    })
    !values.email && !values.password && !values.confirmPassword ?
      this.setState({ fillForm: false }) : this.setState({ fillForm: true })
    try {
      fetch("https://lb9sdrquj5.execute-api.us-west-2.amazonaws.com/dev6/confirm", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: values.email,
          password: values.password,
          confirmationCode: values.token,
          env: process.env.REACT_APP_ENV
        })
      }).then(response => response.json())
        .then(res => res.body.result.Success ? this.props.history.push({
          pathname: '/login',
          state: {
            haveMessage: true,
            msg: "Password successfully changed"
          }
        }) : this.setState({
          errMsg: res.body.result.err,
          loading: false
        }))
      
    } catch (e) {
      this.setState({
        loading: false
      })
    }
  }

  renderField = (field) => {
    const { meta: { touched, error } } = field;
    const className = `form-group ${touched && error ? 'red-text' : ''}`;

    this.setState({ error: error ? true : false })
    return (
      <div className={className}>
        <label>{field.label}</label>
        <input
          id={field.id}
          value={field.value}
          type={field.type}
          disabled={field.disabled}
          {...field.input} />
        <div className="text-help">
          {touched ? error : ''}
          {this.state.changePasswordError}
        </div>
      </div>
    );
  }

  componentDidMount () {
    const initData = {
      "email": this.props.location.state.email
    }
    this.props.initialize(initData)
  }

  render () {
    const { handleSubmit } = this.props
    const { email } = this.props.location.state

    return (
      <div>
        <div className='account'>
          <div className='account__wrapper'>
            <div className='account__card'>
              <div className='account__head'>
                <h3 className='account__title'>Welcome to <span className='account__logo'>Post<span
                  className='account__logo-accent'>ure</span></span></h3>
                <h4 className='account__subhead subhead'>Change your Password</h4>
              </div>
              {this.state.errMsg && this.state.errMsg.includes("Missing") ?
                <div className='error-container'>
                  <ErrorAlert
                    level='danger'
                    msg="Please enter details in all fields before submitting form"
                    alertTag={'Error'} /></div>
                : this.state.errMsg && this.state.errMsg.includes("validation error") ?
                  <div className='error-container'>
                    <ErrorAlert
                      level='danger'
                      msg="Please fix all validation errors before submitting form"
                      alertTag={'Error'} />
                  </div>
                  : this.state.errMsg ?
                    <div className='error-container'>
                      <ErrorAlert
                        level='danger'
                        msg={this.state.errMsg}
                        alertTag={'Error'} />
                    </div>
                    : <div className='error-container'>
                      <ErrorAlert
                        level='success'
                        msg='Password Recovery successful. Check your email for verification code'
                        alertTag={'Success'} />
                    </div>}
              <form className='form' id='ResetPassword' onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                <div className='form__form-group' >
                  <label className='form__form-group-label'>Verification Code</label>
                  <div className='form__form-group-field'>
                    <div className='form__form-group-icon'>
                      <AccountOutlineIcon />
                    </div>
                    <Field
                      id='tokenField'
                      name='token'
                      component={this.renderField}
                      type='token'
                      placeholder='Token'
                    />
                  </div>
                </div>
                <div className='form__form-group' >
                  <label className='form__form-group-label'>Email/Username</label>
                  <div className='form__form-group-field'>
                    <div className='form__form-group-icon'>
                      <AccountOutlineIcon />
                    </div>
                    <Field
                      id='email_Field'
                      name='email'
                      component={this.renderField}
                      disabled={true}
                      type='email'
                      placeholder='Email'
                      value={email}
                    />
                  </div>
                </div>
                <div className='form__form-group' >
                  <label className='form__form-group-label'>Password</label>
                  <div className='form__form-group-field'>
                    <div className='form__form-group-icon'>
                      <AccountOutlineIcon />
                    </div>
                    <Field
                      id='password_Field'
                      name='password'
                      component={this.renderField}
                      type='password'
                      placeholder='Password'
                    />
                  </div>
                </div>
                <div className='form__form-group' >
                  <label className='form__form-group-label'>Confirm Password</label>
                  <div className='form__form-group-field'>
                    <div className='form__form-group-icon'>
                      <AccountOutlineIcon />
                    </div>
                    <Field
                      id='confirmPasswordField'
                      name='confirmPassword'
                      component={this.renderField}
                      type='password'
                      placeholder='Confirm Password'
                    />
                  </div>
                </div>
                {this.state.loading ?
                  <button
                    disabled={true}
                    id='login'
                    type='submit'
                    className='btn btn-primary account__btn account__btn--small loadingBtn'>
                    Loading. Please Wait
                    </button>
                  : <button
                    disabled={this.props.pristine || this.props.submitting || this.props.invalid}
                    id='login'
                    type='submit'
                    className='btn btn-primary account__btn account__btn--small'>
                    Change Password
                  </button>}
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

function validate (values) {
  const errors = {};
  let lowercase = /(?=.*?[a-z])/;
  let uppercase = /(?=.*?[A-Z])/;
  let number = /(?=.*?[0-9])/;
  let specialChar = /[-!$\\#@%^&*()_+|~=`{}[\]:";'<>?,./]/;
  let length = (/.{8,}/)

  if (!values.password) {
    errors.password = "Password is required";
  }

  if (!values.confirmPassword) {
    errors.confirmPassword = "Confirm password is required"
  }

  if (values.confirmPassword && values.password && values.password !== values.confirmPassword) {
    errors.confirmPassword = "Passwords should match"
  }

  if (!values.token) {
    errors.token = "Verification Code is required"
  }

  if (!lowercase.test(values.password)) {
    errors.password = "Password must include a lowercase letter"
  }

  if (!uppercase.test(values.password)) {
    errors.password = "Password must include an uppercase letter"
  }

  if (!number.test(values.password)) {
    errors.password = "Password must include at least one digit"
  }

  if (!length.test(values.password)) {
    errors.password = "Password must be longer than 8 characters"
  }

  if (!specialChar.test(values.password)) {
    errors.password = "Password must contain a special character"
  }

  return errors
}

export default reduxForm({ form: "change_password_form", validate })(withRouter(ChangePassword))


// WEBPACK FOOTER //
// ./src/components/account/log_in/components/ChangePassword.js